import { createSelector } from '@ngrx/store';
import { PnrState, selectPnrState } from '../reducers/pnr.reducer';

export const getSeatMap = createSelector(selectPnrState, (state) => state.seatMap);

export const getLoadingReserveSeat = createSelector(
  selectPnrState,
  (state) => state.loadingReserveSeat
);

export const getReserveSeatResult = createSelector(
  selectPnrState,
  (state) => state.reserveSeatResult
);

export const getSeatListToReserve = createSelector(
  selectPnrState,
  (state: PnrState) => state.seatListToReserve
);
